import { Component } from '../../../libs/gin-tonic/helpers/compiler';

@Component({ className: 'js-event-category-tab' })
export class EventTabComponent {
	constructor(private element: HTMLElement) {
		const eventWrapper = document.querySelector('.js-event-container');
		const width = eventWrapper?.clientWidth;
		document.querySelectorAll('.js-event-col').forEach(elm => {
			elm.setAttribute('style', `width:${width}px`);
		});

		this.onTabClick();
		this.onResize();
	}

	onTabClick() {
		this.element.addEventListener('click', () => {
			const scroll = +(this.element.getAttribute('data-scroll') ?? '0');
			const scrollWidth = document.querySelector('.js-event-container')?.clientWidth;
			const row = document.querySelector('.js-event-row');
			row?.setAttribute('style', `transform:translateX(calc(-1 * ${scroll} * ${scrollWidth}px));`);
			document.querySelectorAll('.js-event-category-tab').forEach(elm => {
				elm.classList.remove('is-active');
			});
			this.element.classList.add('is-active');
		});
	}

	onResize() {
		window.addEventListener('resize', () => {
			const cols = document.querySelectorAll('.js-event-col');
			const width = document.querySelector('.js-event-container')?.clientWidth;
			const scroll = +(document.querySelector('.js-event-category-tab.is-active')?.getAttribute('data-scroll') ?? '0');
			document.querySelector('.js-event-row').setAttribute('style', `transform: translateX(calc(-1 * ${scroll} * ${width}px))`);
			cols.forEach(col => {
				col.setAttribute('style', `width: ${width}px;`);
			});
		});
	}
}
